<template>
  <div class="content">
    <h1><span>District {{ districtInfo.name }}</span> collisions since <span>January 1, 2006</span></h1>
    
    <SeattleCityCouncilInformation></SeattleCityCouncilInformation>
    
    <div class="l-grid l-grid-large">
      <MonthlyCollisions :getters="{
                              average: 'neighborhoodView/monthlyCollisions/average',
                              monthlyCollisions: 'neighborhoodView/monthlyCollisions/get',
                              total: 'neighborhoodView/monthlyCollisions/total'
                            }"></MonthlyCollisions>
      <DamageCosts :getter="'cityCouncilDistrictView/damageCosts/get'"
                   :title="'Economic costs'"
                   :bar-color="this.$store.getters.green.light.a"></DamageCosts>
    </div>

    <div class="l-grid l-grid-small">
      <WhoRank :getters="{rankings: 'cityCouncilDistrictView/whoRank/get'}"></WhoRank>
      <SeverityRank :getters="{rankings: 'cityCouncilDistrictView/severityRank/get'}"></SeverityRank>
      <Weather :card-color="'blue'"
               :card-icon="'cloud'"
               :getter="'cityCouncilDistrictView/weather/get'"
               :table-color="'blue'"
               :title="'Weather'"
               :bar-color="this.$store.getters.blue.light.a"
               :chart-height="380"
               :x-min-axes-rotation="75"></Weather>

      <RoadConditions :card-color="'orange'"
                      :getter="'cityCouncilDistrictView/roadConditions/get'"
                      :table-color="'orange'"
                      :title="'Road conditions'"
                      :bar-color="this.$store.getters.orange.light.a"></RoadConditions>

      <LightConditions :card-color="'yellow'"
                       :card-icon="'wb_incandescent'"
                       :getter="'cityCouncilDistrictView/lightConditions/get'"
                       :table-color="'yellow'"
                       :title="'Light conditions'"
                       :bar-color="this.$store.getters.yellow.light.a"></LightConditions>
      
      <CollisionTypes :card-color="'purple'"
                      :card-icon="'call_split'"
                      :getter="'cityCouncilDistrictView/collisionTypes/get'"
                      :table-color="'purple'"
                      :title="'Collision types'"
                      :bar-color="this.$store.getters.purple.light.a"></CollisionTypes>
      
      <JunctionTypes :card-color="'teal'"
                     :getter="'cityCouncilDistrictView/junctionTypes/get'"
                     :table-color="'teal'"
                     :title="'Junction types'"
                     :bar-color="this.$store.getters.teal.light.b"
                     :chart-height="520"
                     :x-min-axes-rotation="80"></JunctionTypes>
      
      <AddressTypes :card-color="'teal'"
                    :getter="'cityCouncilDistrictView/addressTypes/get'"
                    :table-color="'teal'"
                    :title="'Address types'"
                    :bar-color="this.$store.getters.teal.light.b"></AddressTypes>
    </div>

    <Geo :polygons="polygons"></Geo>
  </div>
</template>

<script>
import SeattleCityCouncilInformation from '@/components/SeattleCityCouncilInformation'

import BarChartWithTable from '@/components/barCharts/BarChartWithTable'
import DamageCosts from '@/components/barCharts/DamageCosts'

import SeverityRank from '@/components/tables/SeverityRank'
import WhoRank from '@/components/tables/WhoRank'
import MonthlyCollisions from '@/components/lineCharts/MonthlyCollisions'
import Geo from '@/components/Geo'

export default {
  name: 'cityCouncilDistrict',

  components: {
    'SeattleCityCouncilInformation': SeattleCityCouncilInformation,
    'AddressTypes': BarChartWithTable,
    'JunctionTypes': BarChartWithTable,
    'CollisionTypes': BarChartWithTable,
    'LightConditions': BarChartWithTable,
    'RoadConditions': BarChartWithTable,
    'Weather': BarChartWithTable,
    'DamageCosts': DamageCosts,
    'MonthlyCollisions': MonthlyCollisions,
    'Geo': Geo,
    'SeverityRank': SeverityRank,
    'WhoRank': WhoRank
  },

  computed: {
    filters () {
      return this.$store.getters['cityCouncilDistrictView/filters']
    },

    districtInfo () {
      return this.$store.getters['cityCouncilDistrictView/pageInfo/get']
    },

    polygons () {
      if (typeof this.districtInfo.polygon !== 'undefined') {
        return [{
          data: [this.districtInfo.polygon],
          options: {
            color: this.$store.getters.teal.dark.a,
            interactive: false
          }
        }]
      }
    }
  },

  mounted: function () {
    this.$store.dispatch('cityCouncilDistrictView/resetResults')
    this.$store.dispatch('cityCouncilDistrictView/setFilters')
    this.$store.dispatch('cityCouncilDistrictView/fetchAll', {id: this.$store.state.route.params.id, filters: this.filters})
  },

  watch: {
    $route: function (to, from) {
      this.$store.dispatch('cityCouncilDistrictView/resetResults')
      this.$store.dispatch('cityCouncilDistrictView/fetchAll', {id: this.$store.state.route.params.id, filters: this.filters})
    }
  },

  beforeRouteLeave (to, from, next) {
    document.getElementById('app').classList.remove('s-map-collapsed', 's-map-default', 's-map-medium', 's-map-full')
    next()
  }
}
</script>



// WEBPACK FOOTER //
// CityCouncilDistrict.vue?abc3508a